import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { workSchedulesService } from '../api/workSchedules.service';
import { WORK_SCHEDULES_KEYS } from './queryKeys';

/**
 * Fetches a single member's work schedule override.
 * Returns `null` when the member has no override (inherits the tenant schedule).
 *
 * @param userId - The member's user id
 * @param enabled - Gate the query (e.g. only fetch while a dialog is open)
 *
 * @remarks
 * `staleTime: 0` so reopening the dialog after an upsert/delete always reflects
 * the latest override state rather than a cached value.
 */
export function useMemberWorkSchedule(userId: string, enabled = true) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: WORK_SCHEDULES_KEYS.member(orgId, userId),
    queryFn: ({ signal }) => workSchedulesService.getMember(userId, signal),
    staleTime: 0,
    enabled: !!orgId && !!userId && enabled,
  });
}
